import React, { useEffect, useState, useCallback, forwardRef } from "react";
import { useIntl } from "react-intl";
import { Mail, Plus, Unlock, Edit, Clock } from "react-feather";
import Tooltip from 'rc-tooltip';
import Pagination from "../../../../components/Pagination";
import LinkUserToEnterpriseModal from './components/LinkUserToEnterpriseModal';
import ConfirmationResendEmailModal from "./components/ConfirmationResendEmailModal";
import NewRegistration from "./components/NewRegistration";
import EditUserModal from "./components/EditUserModal";
import EditUserPasswordModal from "./components/EditUserPasswordModal";
import EditUserTimerModal from "./components/EditUserTimerModal";
import { getUsersListing, api } from "../../../../api";
import { debouncer } from "../../../../utils/debouncer";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";
import Skeleton from "~/components/Skeleton";

const MODAL_LINK_USER = 'MODAL_LINK_USER';
const MODAL_CONFIRMATION_RESEND_EMAIL = 'MODAL_CONFIRMATION_RESEND_EMAIL';
const MODAL_NEW_REGISTRATION = 'MODAL_NEW_REGISTRATION';
const MODAL_EDIT_USER = 'MODAL_EDIT_USER';
const MODAL_EDIT_PASSWORD = 'MODAL_EDIT_PASSWORD';
const MODAL_EDIT_TIMER = 'MODAL_EDIT_TIMER';

const EditUser = ({ setError }) => {
  const { formatMessage } = useIntl();
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [modalSelectedUser, setModalSelectedUser] = useState({});
  const [search, setSearch] = useState('');

  useEffect(() => {
    setLoading(true);
    getUsersListing(page, search)
      .then(({data: response}) => {
        const data = response.data;
        const users = data.results;

        setUsers(users)
        setTotalPages(data.totalPages);
      })
      .catch(() => setError(formatMessage({ id: "erro-api" })))
      .finally(() => {
        setLoading(false);
      });
  }, [page, search], 600);

  const filterUserListing = debouncer((busca) => {
    setSearch(busca);
    setPage(1);
  }, 600);

  const handleResendEmail = useCallback(() => {
    const email = modalSelectedUser;

    api.get(`/b3_estatisticas/resend_user_email?email=${email}`)
      .then(response => {
        alert('E-mail enviado com sucesso!');
        setOpenModal(null);
      })
      .catch(err => {
        setError(formatMessage({ id: 'erro-api' }))
        setOpenModal(null);
      })
  }, [formatMessage, modalSelectedUser, setError]);

  return (
    <>
      <div className="edit-user-box">
        <div className="header-box">
          <div className="column is-6">
            <label htmlFor="search">
              Pesquise por Nome, E-mail ou CPF
              <input
                type="text"
                autoComplete="off"
                name="search-name-or-email"
                id="search"
                placeholder="ex: José | 123.123.123-12 | email@email.com "
                onChange={(e) => filterUserListing(e.target.value)}
              />
            </label>
          </div>
          <div className="header-box">
            <button type="button" onClick={() => {
              setOpenModal(MODAL_NEW_REGISTRATION);
            }}>
              <Plus size={20} />
              Novo Usuário
            </button>
          </div>
        </div>

        <div className="users-table">
          <div className="users-table-header">
            <strong>{formatMessage({ id: 'nome' })}</strong>
            <strong>E-mail</strong>
            <strong>{formatMessage({ id: 'entrou-em' })}</strong>
          </div>

          <div className="users-table-body">
            {loading &&
              Array.from(new Array(8)).map((_, index) => (
                <Skeleton key={index} width="calc(100% - 12px)" ml={12} />
              ))}
            {!loading && users.length === 0 ? (
              <div className="users-table-body-empty">
                <h3>Não há nenhum usuário cadastrado</h3>
              </div>
            ) : (
              <>
                <div>
                  {!loading && users.length > 0 && users.map(user => (
                    <div
                      className="users-table-body-item"
                      key={user.username}
                      onClick={() => {
                        if (selectedUser === user.username) {
                          setSelectedUser('')
                        } else {
                          setSelectedUser(user.username)
                        }
                      }}
                    >
                      <p className="name">{user.name && user.name}</p>
                      <p className="email">{user.username && user.username}</p>
                      <p className="created">{user.created && user.created}</p>

                      <div className="actions">
                        <Tooltip
                          placement="top"
                          trigger={['hover']}
                          overlay={
                            <>
                              <p>Editar Cadastro</p>
                            </>
                          }
                        >
                          <button type="button" onClick={() => {
                            setModalSelectedUser(user.id);
                            setOpenModal(MODAL_EDIT_USER);
                          }}>
                            <Edit size={16} />
                          </button>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          trigger={['hover']}
                          overlay={
                            <>
                              <p>Reenviar email de verificação</p>
                            </>
                          }
                        >
                          <button type="button" onClick={() => {
                            setModalSelectedUser(user.username);
                            setOpenModal(MODAL_CONFIRMATION_RESEND_EMAIL);
                          }}>
                            <Mail size={16} />
                          </button>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          trigger={['hover']}
                          overlay={
                            <>
                              <p>Duração do Acesso</p>
                            </>
                          }
                        >
                          <button type="button" onClick={() => {
                            setModalSelectedUser(user.username);
                            setOpenModal(MODAL_EDIT_TIMER);
                          }}>
                            <Clock size={16} />
                          </button>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          trigger={['hover']}
                          overlay={
                            <>
                              <p>Alterar Senha</p>
                            </>
                          }
                        >
                          <button type="button" onClick={() => {
                            setModalSelectedUser(user.id);
                            setOpenModal(MODAL_EDIT_PASSWORD);
                          }}>
                            <Unlock size={16} />
                          </button>
                        </Tooltip>
                        <Tooltip
                          placement="top"
                          overlay={
                            <>
                              <p>Vincular usuário à PJ</p>
                            </>
                          }
                        >
                          <button type="button" onClick={() => {
                            setModalSelectedUser(user.username);
                            setOpenModal(MODAL_LINK_USER);
                          }}>
                            PJ
                          </button>
                        </Tooltip>
                      </div>
                      
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>

        {users.length > 0 &&
          <Pagination
            page={page}
            totalPages={totalPages}
            setPage={setPage}
          />
        }
      </div>

      {openModal === MODAL_CONFIRMATION_RESEND_EMAIL && (
        <ConfirmationResendEmailModal
          setError={setError}
          user={{
            email: modalSelectedUser
          }}
          onConfirmation={handleResendEmail}
          onClose={() => {
            setOpenModal(null)
          }}
        />
      )}

      {openModal === MODAL_LINK_USER && (
        <LinkUserToEnterpriseModal
          setError={setError}
          data={modalSelectedUser}
          onClose={() => {
            setOpenModal(null)
          }}
        />
      )}

      {openModal === MODAL_NEW_REGISTRATION && (
        <NewRegistration
          setError={setError}
          onClose={() => {
            setOpenModal(null)
          }}
        />
      )}

      {openModal === MODAL_EDIT_USER && (
        <EditUserModal
          setError={setError}
          data={modalSelectedUser}
          onClose={() => {
            setOpenModal(null)
          }}
        />
      )}

      {openModal === MODAL_EDIT_PASSWORD && (
        <EditUserPasswordModal
          setError={setError}
          data={modalSelectedUser}
          onClose={() => {
            setOpenModal(null)
          }}
        />
      )}

      {openModal === MODAL_EDIT_TIMER && (
        <EditUserTimerModal
          setError={setError}
          data={modalSelectedUser}
          onClose={() => {
            setOpenModal(null)
          }}
        />
      )}

    </>
  );
};

export default EditUser;
